import Locked from './Locked'

export default Locked
